import React, { FC, SVGProps } from 'react';
import { cn } from '@ui/lib';

import { iconMap, type IconName } from './iconMap.generated';

export const gluiSizing = {
  none: 0,
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  'xs-sm': '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
  '3xl': '48px',
  '4xl': '64px',
  '5xl': '80px',
  '6xl': '100px',
  '7xl': '128px',
  margin: '20px',
} as const;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'role'> {
  fileName: IconName;
  size?: keyof typeof gluiSizing | number;
  /** Optional descriptive label for the icon */
  ariaLabel?: string;
  role?: string;
}

export function Icon({
  className,
  fileName,
  size = 'lg',
  ariaLabel = 'icon',
  role = 'img',
  ...props
}: IconProps) {
  const sizeClass = typeof size === 'number' ? size : gluiSizing[size];
  try {
    const IconComponent = iconMap[fileName] as React.FC<
      React.SVGProps<SVGSVGElement>
    >;

    if (!IconComponent) throw Error('Icon not found');

    return (
      <IconComponent
        height={sizeClass}
        width={sizeClass}
        className={className}
        aria-label={ariaLabel}
        role={role}
        {...(props as React.SVGProps<SVGSVGElement>)}
      />
    );
  } catch (error) {
    console.error('Icon not found', fileName);
    return <div>Icon not found</div>;
  }
}
